import React from 'react';
import {t} from '@lingui/core/macro';

import {PasswordResetInit} from 'features/auth';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';


const PasswordResetInitPage: React.FC = () => {
    return (
        <BlankLayout pageTitle={t`Сброс пароля`}>
            <PasswordResetInit/>
        </BlankLayout>
    );
};

export default PasswordResetInitPage;